/**
 * Created by bhadaway on 3/20/18.
 */
import { combineReducers } from 'redux'
import filterReducer from './filterReducer'

export default combineReducers({
  filterReducer
})